import { useEffect, useRef, useState } from "react";

import moment from "moment";
import AutoScrollUtils from "../../../../../../util/AutoScrollUtils";
import AlarmEventApi from "../../../../../../api/AlarmEventApi";
import { DeviceAlarmsWrapper, AlarmEvents, TableHeader, TableContent,TableHeaderRow, EventTime, EventDetails, EventStatus, TableRow } from "./DeviceAlarms.styled";

interface DeviceAlarmsProps {
    deviceId: string
}

export const DeviceAlarms: React.FC<DeviceAlarmsProps> = (props)=> {
    // api
    let alarmEventApi = new AlarmEventApi();

    // state
    let [alarmEvents, setAlarmEvents] = useState([]);
    let carouselRef = useRef<any>();

    // function
    let formatDateTime = (timestamp: number | string)=> {
        timestamp = Number(timestamp);
        return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
    }

    // onload
    useEffect(()=> {
        let loadAlarmEventViews = async ()=> {
            let deviceViews = (await alarmEventApi.queryViews({
                deviceId: props.deviceId,
                pageNo: 1,
                pageSize: 50,
            })).data.data.elements;
            setAlarmEvents(deviceViews);
        }
        loadAlarmEventViews();

        let refreshTask = setInterval(()=> {
            loadAlarmEventViews();
        }, 5000);

        return ()=> {
            clearInterval(refreshTask);
            if (carouselRef.current) {
                AutoScrollUtils.removeAutoScroll(carouselRef.current);
            }
        }
    }, []);

    let initializeListCarousel = (dom) => {
        if (dom) {
            carouselRef.current = AutoScrollUtils.addAutoScroll(dom);
        } else {
            if (carouselRef.current) {
                AutoScrollUtils.removeAutoScroll(carouselRef.current);
            }
        }
    };

    let formatEventTime = (timestamp: number | string) => {
        timestamp = Number(timestamp);
        return moment(timestamp).format('YY/MM/DD HH:mm');
    }

    // render
    return (
        <DeviceAlarmsWrapper>
                <AlarmEvents>
                    <TableHeader>
                        <TableHeaderRow>
                            <EventTime>事件时间</EventTime>
                            <EventDetails>事件详情</EventDetails>
                            <EventStatus>事件状态</EventStatus>
                        </TableHeaderRow>
                    </TableHeader>

                    {
                        alarmEvents.length === 0 ? <TableRow><EventTime>暂无报警事件</EventTime></TableRow> : 
                            <TableContent ref={(dom)=> initializeListCarousel(dom)}>
                                {
                                    alarmEvents.map((e)=> {
                                        return <TableRow key={e.event.id}>
                                            <EventTime className="value">{formatEventTime(parseInt(e.event.eventTime || e.event.startTime))}</EventTime>
                                            <EventDetails>{e.event.details}</EventDetails>
                                            <EventStatus style={{color: e.event.acked ? '#1EA77B' : '#E70302'}}>{e.event.acked ? '已处理' : '未处理'}</EventStatus>
                                        </TableRow>
                                    })
                                }
                            </TableContent>
                    }
                </AlarmEvents>
        </DeviceAlarmsWrapper>
    )
};
export default DeviceAlarms;